import React, { useState } from 'react';
import './settings.css'; 

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add validation & API integration here
    console.log('Password Update Submitted:', formData);
  };

  return (
    <div className="update-password-container">
      <p>Please update your password below.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Old password</label>
          <input
            type="password"
            name="oldPassword"
            placeholder="Enter Old Password"
            value={formData.oldPassword}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>New password</label>
          <input
            type="password"
            name="newPassword"
            placeholder="Enter New Password"
            value={formData.newPassword}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Confirm password</label>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Enter New Password Again"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="update-btn">Update</button>
      </form>
    </div>
  );
};

export default ChangePassword;
